import styled from "styled-components";

export const ErrorH2 = styled.h2`
  margin: 3rem auto;
  font-size: clamp(3rem, 2.5vw, 4.8rem);
  text-align: center;
`;
